import {
	FormItem,
	ReorderableList,
	TextInput,
	ValidationError,
} from "client/Components";
import styles from "./WebDavServersTab.module.less";
import { IValueInputAttachable } from "client/Forms/attachable";
import { useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { WebDavServerModel } from "client/Api/WebDavSettings/webDavSettings";
import {setClientId} from "client/Misc/clientId";

type WebDavServersTabProps = {
	serversAttachable: IValueInputAttachable<WebDavServerModel[]>;
};

export const WebDavServersTab = (props: WebDavServersTabProps) => {
	const { serversAttachable } = props;

	const handleServerPanelsMove = useCallback(
		(from: number, to: number) => {
			const panels = [...serversAttachable.value];

			[panels[from], panels[to]] = [panels[to], panels[from]];

			serversAttachable.reducer.setValue(panels);
		},
		[serversAttachable]
	);

	const handleAddServerClick = useCallback(() => {
		const newServer: WebDavServerModel = setClientId({
			url: "",
			name: ""
		});

		serversAttachable.reducer.push(newServer);
	}, [serversAttachable]);

	const removeServerPanelHandler = useCallback(
		(index: number): void => {
			serversAttachable.reducer.removeAt(index);
		},
		[serversAttachable]
	);

	const serverPanels = serversAttachable
		.map((panelHandler, index) => (
			<ReorderableList.PanelItem
				key={index}
				header={
					<TextInput
						{...panelHandler.for("name").attachToTextInput()}
						placeholder={localize("_Name")}
					/>
				}
				onRemove={() => removeServerPanelHandler(index)}
			>
				<ValidationError {...panelHandler.for("name").attachToValidationError()} />
				<FormItem label={localize("_WebDavUrl")}>
					<TextInput
						{...panelHandler.for("url").attachToTextInput()}
					/>
					<ValidationError
						{...panelHandler.for("url").attachToValidationError()}
					/>
				</FormItem>
			</ReorderableList.PanelItem>
		));

	return (
		<div className={styles.tabContent}>
			<h3 className={styles.title}>{localize("_FileServers")}</h3>
			<ReorderableList onItemMove={handleServerPanelsMove}>
				{serverPanels}
			</ReorderableList>
			<ReorderableList.AddButton onClick={handleAddServerClick} />
		</div>
	);
};
